import { ImpersonateUsersModel } from '@/models/console/impersonate-users';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import { sessionService } from '@/providers/services/auth/session';

export class ConsoleSerializer {

    private static INSTANCE = new  ConsoleSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    /**
     * Help to serialize impersonate users list
     */
    public impersonateUserListSerialzer(payload: any) {
        const result: ImpersonateUsersModel[] = [];
        const cdnUrls = sessionService.getCdnUrl();
        const userCdnUrl = cdnUrls.user_cdn_url;
        const usersList: any = payload.users  ? payload.users : [];
        if (usersList.length) {
            usersList.map((user: any) => {
                const thumbnailUrl = user.thumbnail
                    ? userCdnUrl + user.thumbnail
                    : DEFAULT_IMAGES_PATH.profile;
                const userDetails: ImpersonateUsersModel = {
                    id: user.id,
                    firstName: user.first_name,
                    lastName: user.last_name,
                    displayName: user.display_name,
                    thumbnailUrl,
                    emailId: user.email,
                    status: user.status,
                    category: user.category,
                };
                result.push(userDetails);
            });
        }
        return result;
    }
}

export const consoleSerializer = ConsoleSerializer.instance;
